<template>
  <path pid="0" d="M7.5 3a4 4 0 102 7.45L12.08 13l-2.55 2.55A4 4 0 1011 17L22.21 5.71a1 1 0 000-1.42l-.1-.08a1 1 0 00-1.32.08l-7.29 7.3L11 9a4 4 0 00-3.5-6zm1.43 5.39A2 2 0 119.5 7a2 2 0 01-.61 1.43zM7.5 21a2 2 0 111.39-3.43A2 2 0 017.5 21z"/><path pid="1" d="M22.21 20.29l-5.53-5.52a1 1 0 10-1.42 1.42l5.53 5.52a1 1 0 001.42-1.42z"/>
</template>
